export function switchTimeFormats(value: unknown): Date | null {
  if (!value) { return null; }

  const now = new Date();
  const [hours, minutes] = (value as string)
    .split(/[:.]/)
    .map(part => parseInt(part || '0', 10));

  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
}
